import { color } from '@primer-io/goat'
import * as ArticleComponents from 'components/ArticleComponents'
import { FullWidthGuide, OverviewSection, OverviewTopSection } from 'components/OverviewComponents'
import React from 'react'
import ObsMonitors from '../assets/monitors.png'
import ObsDashboards from '../assets/obs-dashboards.png'
import GuideLinks from './GuideLinks'
import ObsUseCases from './UseCases'

const fullWidthGuidesData = [
	{
		title: 'Dashboards',
		description:
			'Curated payments analytics dashboards that help you to identify optimizations in your payment orchestration flows easily',
		imgBackground: color('yellow-200'),
		imgSrc: ObsDashboards,
		buttonContent: 'Get started',
		to: './dashboards',
	},
	{
		title: 'Monitors',
		description:
			'Setup real-time alerting and receive instant notifications of any spikes or drops in key performance metrics directly to your mailbox or Slack channel',
		imgBackground: color('green-300'),
		imgSrc: ObsMonitors,
		buttonContent: 'Get started',
		to: './monitors',
	},
]

export default function ObsOverview() {
	return (
		<ArticleComponents.Wrapper>
			<OverviewSection>
				<OverviewTopSection
					title='Observability'
					description={
						<>
							<ArticleComponents.P>
								Uncover opportunities that boost your bottom line with complete visibility into your payment stack.
							</ArticleComponents.P>
						</>
					}
				/>
			</OverviewSection>
			<OverviewSection>
				{fullWidthGuidesData.map((guide, index) => (
					<React.Fragment key={index}>
						<FullWidthGuide
							title={guide.title}
							description={guide.description}
							imgBackground={guide.imgBackground}
							imgSrc={guide.imgSrc}
							buttonContent={guide.buttonContent}
							to={guide.to}
						/>
						{index < fullWidthGuidesData.length - 1 && <br />}
					</React.Fragment>
				))}
			</OverviewSection>
			<OverviewSection>
				<ArticleComponents.Wrapper>
					<OverviewSection>
						<ArticleComponents.H2>Use Cases</ArticleComponents.H2>
						<ObsUseCases />
					</OverviewSection>
				</ArticleComponents.Wrapper>
			</OverviewSection>
			<OverviewSection>
				<ArticleComponents.H2>Analyse all your payments data in one place</ArticleComponents.H2>
				<GuideLinks />
			</OverviewSection>
		</ArticleComponents.Wrapper>
	)
}
